import React, { useState, useRef, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import ImageSlider from "./components/ImageSlider";
import ImageChanger from "./components/ScrollSlider";
import CatalogueNavbar from "./components/CatalogueNavbar";
import FooterCatalogue from "./components/FooterCatalogue";
import DotsIndicator from "./components/DotsIndicator";
const Catalogue = () => {
  // contact us div redirect start

  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      // Remove the '#' from the hash to get the element id
      const targetId = location.hash.replace("#", "");
      const targetElement = document.getElementById(targetId);
      if (targetElement) {
        targetElement.scrollIntoView({ behavior: "smooth" });
      }
    }
  }, [location]);

  // contact us div redirect end
  const [highlightedRow, setHighlightedRow] = useState(0);

  useEffect(() => {
    const intervalId = setInterval(() => {
      setHighlightedRow((prev) => (prev + 1) % 4); // There are 4 rows, loop from 0 to 3
    }, 2000); // Change highlight every 2 seconds

    return () => clearInterval(intervalId); // Cleanup on unmount
  }, []);

  const rows = [
    {
      left: "01",
      right: (
        <div className="container ">
          <div className=" ">
            <div className="  ">
              <div className="text-lg text-left font-bold">
                Detailed Quotation & Order Updates
              </div>
            </div>
            <div className="">
              <p className="text-sm  text-left">
                Buy certified fabrics Select from pre-sourced and certified
                fabrics in over 300 varieties of Cotton, Cellulose, Sustainable,
                Silk and Polyester.
              </p>
            </div>
          </div>
        </div>
      ),
    },
    {
      left: "02",
      right: (
        <div className="container ">
          <div className=" ">
            <div className="  ">
              <div className="text-lg text-left font-bold">
                Design Development
              </div>
            </div>
            <div className="">
              <p className="text-sm  text-left">
                Choose from our ever growing catalogue of thousands of designs
                or get your own design customized.
              </p>
            </div>
          </div>
        </div>
      ),
    },
    {
      left: "03",
      right: (
        <div className="container ">
          <div className=" ">
            <div className="  ">
              <div className="text-lg text-left font-bold">
                Controlled Production
              </div>
            </div>
            <div className="">
              <p className="text-sm  text-left">
                Each of our partner production units are monitored by our own
                team on 7+ parameters everyday, thus ensuring quality and
                real-time updates.
              </p>
            </div>
          </div>
        </div>
      ),
    },
    {
      left: "04",
      right: (
        <div className="container ">
          <div className=" ">
            <div className="  ">
              <div className="text-lg text-left font-bold">
                Testing & Quality Inspection
              </div>
            </div>
            <div className="">
              <p className="text-sm  text-left">
                Our In-house inspection unit analyses over 20 types of
                defects.Get our proprietary shrinkage and color fastness test
                report for each order
              </p>
            </div>
          </div>
        </div>
      ),
    },
  ];

  // simplifying madura end
  return (
    <div className="font-Manrope">
      <CatalogueNavbar />
      {/* Banner start */}
      <div className="h-[70vh] md:h-[95vh] relative">
        <video
          src="/CatBanner.mp4"
          autoPlay
          loop
          muted
          className="absolute top-0 left-0 w-full h-full object-cover"
        ></video>
        {/* Content overlay */}
        <div className="absolute top-0 left-0 w-full h-full flex items-center justify-center">
          <div className="w-[85%] md:w-[70%]">
            <div className="text-center text-white">
              <h1 className="text-3xl md:text-5xl font-light ">
                Crafting <span className="font-medium">Fabric &</span>
              </h1>

              <h1 className="text-3xl md:text-5xl font-medium mb-4 mt-2">
                Garment Excellence
              </h1>
              <p className="text-lg pl-20 mt-4 pr-20 hidden md:block ">
                At the heart of our operations is a commitment to delivering
                superior products through cutting - edge technology and
                innovative processes.
              </p>
            </div>
          </div>
          {/* Bottom Features */}
          <div className="absolute text-white bottom-10  flex flex-col md:flex-row items-center justify-center md:space-x-24 space-y-3 md:space-y-0">
            {/* Feature 3 */}
            <div className="flex items-center justify-center space-x-2">
              <img
                src="/feature-icon.svg" // Ensure this is the correct path
                alt="State-of-the-Art Technology"
                className="h-4 w-4"
              />
              <p className="text-sm">State-of-the-Art Technology</p>
            </div>

            {/* Feature 2 */}
            <div className="flex items-center justify-center space-x-2">
              <img
                src="/feature-icon.svg" // Ensure this is the correct path
                alt="Quality Assurance Systems"
                className="h-4 w-4"
              />
              <p className="text-sm">Quality Assurance Systems</p>
            </div>

            {/* Feature 1 */}
            <div className="flex items-center justify-center space-x-2">
              <img
                src="/feature-icon.svg" // Ensure this is the correct path
                alt="Advanced Manufacturing Solutions"
                className="h-4 w-4"
              />
              <p className="text-sm">Advanced Manufacturing Solutions</p>
            </div>
          </div>
        </div>
      </div>
      {/* Banner end */}
      {/* Category selection start */}
      <div className="relative pt-8 px-4 sm:px-10 md:px-12 pb-8 bg-white">
        <div className="flex flex-row items-center">
          <img
            src="/Categories.svg" // Make sure this is the correct path
            alt="Categories"
            className="h-3 w-3"
          />
          <p className="text-sm pl-2">CATEGORIES</p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-3 md:mt-6">
          <div className="text-black text-2xl md:text-4xl">
            <p>
              Your One stop{" "}
              <span className="font-bold">Fabric & Garment Haven</span>
            </p>
          </div>
          <div className="text-black text-sm -mt-4 md:mt-0  md:text-base md:pl-12 lg:pr-24 font-light">
            <p>
              We Take Complete Ownership from Yarn Sourcing to Packing &
              Shipping, we have the expertise and resources to bring your vision
              to life, ensuring high-quality execution with speed and precision.
            </p>
          </div>
        </div>
        <div className="mt-3 max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-16 h-auto">
          <div>
            <a href="/Fabrics">
              <div
                className="rounded-[15px] overflow-hidden bg-cover bg-center w-full h-[20vh] md:h-[45vh]"
                style={{ backgroundImage: "url('/FabricCat.png')" }}
              ></div>
              <div className="mt-6 pb-2 md:pt-0 md:pb-0 md:p-6 flex items-center justify-between">
                <div>
                  <h2 className="text-lg mb-2">Fabrics</h2>
                  <p className="text-gray-600 text-sm">
                    We have our fabric store with wide variety of fabrics.
                    Whether you are a designer looking for bulk purchase or an
                    individual looking to stitch your own outfit we have you
                    covered.
                  </p>
                </div>
                <div className="ml-2">
                  <button className="rounded-md">
                    <img
                      src="/CatLink.svg"
                      alt="Link"
                      className="h-24 w-24 md:h-14 md:w-14"
                    />
                  </button>
                </div>
              </div>
            </a>
          </div>

          <div className="">
            <a href="/Garments">
              <div
                className="rounded-[15px] overflow-hidden bg-cover bg-center w-full h-[20vh] md:h-[45vh]"
                style={{ backgroundImage: "url('/GarmentCat.png')" }}
              ></div>
              <div className="mt-6 pb-2 md:pt-0 md:pb-0 md:p-6 flex items-center justify-between">
                <div>
                  <h2 className="text-lg mb-2">Garments</h2>

                  <p className="text-gray-600 text-sm">
                    In our garment line, we are featuring complete in-house
                    manufacturing expertise, ensuring quality and innovation
                    from start to finish.
                  </p>
                </div>
                <div className="ml-2">
                  <button className="rounded-md">
                    <img
                      src="/CatLink.svg"
                      alt="Link"
                      className="h-20 w-20 md:h-14 md:w-14"
                    />
                  </button>
                </div>
              </div>
            </a>
          </div>
        </div>
        {/* Ensure the image does not overlap by adjusting its positioning and size responsively */}
        <a href="/Garments">
          {" "}
          <img
            src="/CatVector.png"
            alt="Background Decor"
            className="hidden md:block absolute -bottom-16 right-0  w-[40%]  md:w-[40%] lg:w-[40%]  h-[300px] md:h-auto object-contain z-0"
          />
        </a>
      </div>

      {/* Category selection end */}
      {/* auto scroll process start */}
      <div>
        <div className="hidden md:block">
          <ImageChanger></ImageChanger>
        </div>
        <div className=" block md:hidden">
          <DotsIndicator />
        </div>
        {/* auto scroll process end  */}
      </div>
      {/* Simplified with madura start */}
      <div className="container   mx-auto p-8 md:p-12 bg-[#F5F5F5]">
        <div className="flex flex-row items-center ">
          <img
            src="/Categories.svg" // Replace with your SVG file path
            alt="C"
            className="h-3 w-3 "
          />
          {/* Replace with your icon */}
          <p className="text-sm pl-2">SIMPLIFIED WITH MADURA</p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {/* First row */}
          <div className=" pt-6 pb-4 text-4xl md:text-5xl">
            Your{" "}
            <span className="font-bold ">
              Fabric & Garment Sourcing Journey
            </span>
          </div>
          <div className=" md:p-4">
            Our process is designed to maximize efficiency and quality at every
            stage of production. By integrating advanced technologies and best
            practices, we ensure seamless workflows.
          </div>
          {/* Second row */}
          <div className=" md:p-4">
            {/* Image slider start */}

            <ImageSlider />

            {/* Image slider end */}
          </div>
          <div className="container mx-auto ">
            {rows.map((row, index) => (
              <div
                key={index}
                className={`grid grid-cols-[10%_90%] gap-4 mb-2 p-3 rounded-xl transition-colors duration-500 ${
                  highlightedRow === index
                    ? "bg-[#495F86] text-white"
                    : "bg-transparent text-[#222222]"
                }`}
                style={{ borderRadius: "0.5rem" }}
              >
                <div
                  className={`font-bold text-3xl flex justify-center items-center transition-colors duration-500 ${
                    highlightedRow === index ? "text-white" : "text-[#495F86]"
                  }`}
                >
                  {row.left}
                </div>
                <div
                  className={`flex justify-start items-center transition-colors duration-500 text-left ${
                    highlightedRow === index ? "text-white" : "text-[#222222]"
                  }`}
                >
                  {typeof row.right === "string" ? (
                    <p>{row.right}</p>
                  ) : (
                    row.right
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
      {/* Simplified with madura end */}
      {/* Fabric showcase start */}
      <div className="p-8">
        {" "}
        <div className="flex flex-row items-center ">
          <img
            src="/Categories.svg" // Replace with your SVG file path
            alt="C"
            className="h-3 w-3 "
          />
          {/* Replace with your icon */}
          <p className="text-sm pl-2">Our Touch</p>
        </div>
        <div className="flex flex-wrap">
          {/* View all button in phone start*/}
          <div className="relative w-full h-full block md:hidden ">
            <button className=" flex items-center rounded overflow-hidden bg-[#465b83] shadow-lg border-2 border-[#465b83] absolute -top-6 right-0">
              {/* Contact Us Text Section */}
              <div className="bg-white text-[#465b83] px-2 py-1 text-sm rounded">
                {" "}
                {/* Reduced padding and smaller text */}
                View All
              </div>
              {/* Icon Section */}
              <div className="bg-[#465b83] p-1">
                {" "}
                {/* Reduced padding */}
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 25 26"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M7.69531 19.6176C7.39531 19.6176 7.19531 19.5119 6.99531 19.3007C6.59531 18.8783 6.59531 18.2446 6.99531 17.8222L16.9953 7.26117C17.3953 6.83873 17.9953 6.83873 18.3953 7.26117C18.7953 7.68361 18.7953 8.31727 18.3953 8.73971L8.39531 19.3007C8.19531 19.5119 7.99531 19.6176 7.69531 19.6176Z"
                    fill="white"
                  />
                  <path
                    d="M17.6953 18.5615C17.0953 18.5615 16.6953 18.139 16.6953 17.5054V9.05654H8.69531C8.09531 9.05654 7.69531 8.6341 7.69531 8.00044C7.69531 7.36678 8.09531 6.94434 8.69531 6.94434H17.6953C18.2953 6.94434 18.6953 7.36678 18.6953 8.00044V17.5054C18.6953 18.139 18.2953 18.5615 17.6953 18.5615Z"
                    fill="white"
                  />
                </svg>
              </div>
            </button>
          </div>
          {/* View all button in phone end */}

          {/* First Column (Responsive 50% width) */}
          <div className="w-full md:w-[40%] p-4 text-3xl">
            Our Versatile<span className="font-bold"> Fabric Collections</span>
          </div>

          {/* Second Column (Responsive 50% width with button in top-right) */}
          <div className="hidden md:block md:w-[60%] p-4  relative ">
            <a href="/Fabrics">
              <button className="flex items-center rounded overflow-hidden bg-[#465b83] shadow-lg border-2 border-[#465b83] absolute top-0 right-0">
                {/* Contact Us Text Section */}
                <div className="bg-white text-[#465b83] px-2 py-1 text-sm rounded">
                  {" "}
                  {/* Reduced padding and smaller text */}
                  View All
                </div>
                {/* Icon Section */}
                <div className="bg-[#465b83] p-1">
                  {" "}
                  {/* Reduced padding */}
                  <svg
                    width="20"
                    height="20"
                    viewBox="0 0 25 26"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M7.69531 19.6176C7.39531 19.6176 7.19531 19.5119 6.99531 19.3007C6.59531 18.8783 6.59531 18.2446 6.99531 17.8222L16.9953 7.26117C17.3953 6.83873 17.9953 6.83873 18.3953 7.26117C18.7953 7.68361 18.7953 8.31727 18.3953 8.73971L8.39531 19.3007C8.19531 19.5119 7.99531 19.6176 7.69531 19.6176Z"
                      fill="white"
                    />
                    <path
                      d="M17.6953 18.5615C17.0953 18.5615 16.6953 18.139 16.6953 17.5054V9.05654H8.69531C8.09531 9.05654 7.69531 8.6341 7.69531 8.00044C7.69531 7.36678 8.09531 6.94434 8.69531 6.94434H17.6953C18.2953 6.94434 18.6953 7.36678 18.6953 8.00044V17.5054C18.6953 18.139 18.2953 18.5615 17.6953 18.5615Z"
                      fill="white"
                    />
                  </svg>
                </div>
              </button>
            </a>
          </div>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-4 p-4">
          {/* Box 1 */}
          <a href="/Fabrics/Pique">
            <div className="flex flex-col items-center bg-white md:p-4 ">
              <img
                src="/fabrics/Pique.png"
                alt="Airtex"
                className="w-full h-40 object-cover rounded-lg mb-2"
              />
              <p className="text-center font-semibold">Pique Knit Fabric</p>
            </div>
          </a>

          {/* Box 2 */}
          <a href="/Fabrics/SingleJersey">
            <div className="flex flex-col items-center bg-white md:p-4 ">
              <img
                src="/fabrics/SingleJersey.png"
                alt="Single Jersey"
                className="w-full h-40 object-cover rounded-lg mb-2"
              />
              <p className="text-center font-semibold">
                Single Jersey Knit Fabric
              </p>
            </div>
          </a>

          {/* Box 3 */}
          <a href="/Fabrics/Interlock">
            <div className="flex flex-col items-center bg-white md:p-4">
              <img
                src="/fabrics/Intelock.png"
                alt="Cameron Williamson"
                className="w-full h-40 object-cover rounded-lg mb-2"
              />
              <p className="text-center font-semibold">Interlock Knit Fabric</p>
            </div>
          </a>
          {/* Box 4 */}
          <a href="/Fabrics/Jacquard">
            <div className="flex flex-col items-center bg-white md:p-4 ">
              {/* <Link to="/Fabrics/Jacquard"> */}
              <img
                src="/fabrics/Jacquard.png"
                alt="Darlene Robertson"
                className="w-full h-40 object-cover rounded-lg mb-2"
              />
              <p className="text-center font-semibold">Jacquard Knit Fabric</p>
              {/* </Link> */}
            </div>
          </a>
        </div>
      </div>
      {/* Fabric showcase end */}
      {/* contact us start */}
      <div>
        <div className="bg-[#F5F5F5] p-4 sm:p-8 flex flex-col sm:flex-row justify-center items-center relative">
          <div className="max-w-6xl w-full flex flex-col md:flex-row">
            {/* Left Section: Contact Details */}
            <div className="flex-1 p-4 space-y-4">
              <h2 className="text-xl md:text-3xl font-semibold text-gray-800">
                Get in touch with us
              </h2>
              <p className="text-gray-600">
                Reach out for any inquiries, support, or to discuss how we can
                meet your needs.
              </p>
              {/* Contact Information */}
              <div className="space-y-4">
                <div className="flex items-center space-x-4">
                  <div className="p-3   text-white">
                    <svg
                      width="36"
                      height="36"
                      viewBox="0 0 60 61"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <rect
                        x="0.5"
                        y="1.08008"
                        width="59"
                        height="59"
                        rx="9.5"
                        fill="#465B83"
                      />
                      <rect
                        x="0.5"
                        y="1.08008"
                        width="59"
                        height="59"
                        rx="9.5"
                        stroke="#465B83"
                      />
                      <path
                        d="M34.6306 44.3731C34.51 44.3731 34.3885 44.3626 34.2679 44.3409C30.1166 43.5936 25.9784 41.3308 22.6159 37.9682C19.2534 34.6057 16.9904 30.4675 16.2431 26.3161C16.1024 25.5327 16.4307 24.7178 17.0796 24.2401C17.9107 23.6285 18.8062 23.0599 19.7407 22.5512C20.3603 22.214 21.0908 22.1952 21.6961 22.5002C23.7656 23.5433 25.1373 25.2807 25.7731 27.6639C25.9456 28.3088 25.792 29.0082 25.3625 29.5344L23.9913 31.2122C23.7715 31.4813 23.7448 31.8523 23.9249 32.1357C25.0914 33.9711 26.613 35.4927 28.4485 36.6589C28.7315 36.8394 29.1025 36.8123 29.3719 36.5928L31.0494 35.2219C31.5759 34.7921 32.2744 34.6388 32.9205 34.811C35.3034 35.4471 37.0408 36.8189 38.0839 38.8883C38.3892 39.493 38.3704 40.2238 38.0332 40.8434C37.5242 41.7779 36.9556 42.6734 36.3436 43.5045C35.9398 44.0534 35.2943 44.3731 34.6306 44.3731ZM20.7784 23.5972C20.6413 23.5972 20.5 23.6331 20.3689 23.7046C19.4862 24.1851 18.6418 24.7212 17.8583 25.2978C17.6095 25.4811 17.4829 25.7894 17.5359 26.0835C18.2359 29.9738 20.3697 33.8647 23.5444 37.0397C26.7194 40.2144 30.6103 42.3481 34.5006 43.0481C34.7953 43.1009 35.103 42.9744 35.286 42.7259C35.8629 41.9424 36.399 41.0979 36.8798 40.2152C37.0106 39.9747 37.0225 39.6996 36.9114 39.4797C36.0315 37.7345 34.6155 36.6224 32.5816 36.0798C32.3434 36.0165 32.0806 36.0755 31.8802 36.2391L30.2029 37.6097C29.4942 38.1888 28.5055 38.2521 27.7439 37.7673C25.7449 36.4971 24.087 34.8391 22.8165 32.8402C22.332 32.0781 22.3953 31.0896 22.9744 30.3811L24.3453 28.7036C24.5086 28.5035 24.5681 28.2416 24.5043 28.0027C23.9617 25.9687 22.8496 24.5525 21.1048 23.6727C21.0044 23.6222 20.893 23.5972 20.7784 23.5972Z"
                        fill="white"
                      />
                      <path
                        d="M43.1214 31.2731C43.112 31.2731 43.1026 31.2728 43.0934 31.2725C42.7309 31.2574 42.4497 30.9513 42.4648 30.5891C42.605 27.2428 41.3318 23.9701 38.972 21.6097C36.6119 19.2499 33.346 17.9702 29.9926 18.117C29.6438 18.1261 29.3243 17.8511 29.3092 17.4883C29.2941 17.126 29.5754 16.8199 29.9376 16.8048C33.6504 16.6475 37.281 18.062 39.9005 20.6812C42.5197 23.3004 43.9325 26.9319 43.7769 30.644C43.762 30.9969 43.4714 31.2731 43.1214 31.2731Z"
                        fill="white"
                      />
                      <path
                        d="M39.6275 31.2733C39.6147 31.2733 39.6016 31.273 39.5884 31.2722C39.2262 31.2508 38.95 30.9402 38.9714 30.5781C39.114 28.157 38.215 25.7875 36.5047 24.0772C34.7944 22.3669 32.4235 21.4703 30.0037 21.6105C29.6398 21.6347 29.3311 21.3557 29.3098 20.9935C29.2884 20.6315 29.5646 20.3209 29.9268 20.2995C32.7187 20.1333 35.4582 21.1733 37.4333 23.1487C39.4086 25.124 40.4472 27.8601 40.2824 30.6552C40.2619 31.0042 39.9726 31.2733 39.6275 31.2733Z"
                        fill="white"
                      />
                      <path
                        d="M36.1376 31.2732C36.1171 31.2732 36.0966 31.2724 36.0758 31.2704C35.7146 31.2367 35.4493 30.9167 35.483 30.5556C35.622 29.0644 35.0954 27.6024 34.0374 26.5444C32.9795 25.4868 31.5185 24.9595 30.0262 25.0989C29.6655 25.1317 29.3448 24.8672 29.3115 24.5061C29.2778 24.145 29.5432 23.8249 29.9042 23.7913C31.7875 23.616 33.631 24.2809 34.966 25.6159C36.3012 26.9509 36.9661 28.796 36.7906 30.6775C36.7589 31.0179 36.4728 31.2732 36.1376 31.2732Z"
                        fill="white"
                      />
                    </svg>
                  </div>
                  <div>
                    <p className="text-gray-800 font-medium">Contact</p>
                    <p className="text-gray-600">
                      <a href="tel:+919445202342">+91 9445202342</a>
                    </p>
                  </div>
                </div>
                <div className="flex items-center space-x-4">
                  <div className="p-3  text-white">
                    {/* Mail Icon */}
                    <svg
                      width="36"
                      height="36"
                      viewBox="0 0 60 61"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <rect
                        x="0.5"
                        y="1.08008"
                        width="59"
                        height="59"
                        rx="9.5"
                        fill="#465B83"
                      />
                      <rect
                        x="0.5"
                        y="1.08008"
                        width="59"
                        height="59"
                        rx="9.5"
                        stroke="#465B83"
                      />
                      <path
                        d="M39.5077 19.2158C36.9419 19.2158 34.7814 20.9844 34.1812 23.3665H17.1947C16.6206 23.3665 16.0782 23.5866 15.6662 23.9864L15.6649 23.9876L15.6608 23.9916C15.2347 24.4081 15 24.9655 15 25.5612V39.7545C15 40.359 15.253 40.9425 15.694 41.3554L15.6966 41.3579C16.1046 41.7392 16.6365 41.9492 17.1947 41.9492H37.899C38.4554 41.9492 38.9858 41.7406 39.393 41.3617C39.396 41.3591 39.3988 41.3564 39.4017 41.3536C39.8415 40.9405 40.0936 40.358 40.0936 39.7545V30.1694C42.8477 29.876 45 27.5387 45 24.7081C45 21.6797 42.5362 19.2158 39.5077 19.2158ZM17.1947 24.5384H34.0181C34.0164 24.5948 34.0155 24.6513 34.0155 24.7081C34.0155 25.7575 34.3113 26.739 34.8239 27.5738L27.9298 34.0907H27.1639L17.067 24.5463C17.109 24.5411 17.1517 24.5384 17.1947 24.5384ZM16.1719 25.5612C16.1719 25.4845 16.1803 25.4092 16.1965 25.3362L24.4049 33.0954L16.2173 40.0573C16.1876 39.9607 16.1719 39.8591 16.1719 39.7545V25.5612ZM37.899 40.7773H17.1947C17.1899 40.7773 17.1852 40.7767 17.1804 40.7766L25.2616 33.9052L26.5283 35.1025C26.6371 35.2054 26.7812 35.2626 26.9309 35.2626H28.1629C28.3126 35.2626 28.4566 35.2053 28.5654 35.1025L29.8321 33.9052L37.9139 40.7772C37.9089 40.7772 37.9039 40.7773 37.899 40.7773ZM38.9218 39.7545C38.9218 39.8591 38.9064 39.9609 38.8766 40.0575L30.6887 33.0953L35.5437 28.506C36.4169 29.417 37.6 30.0286 38.9218 30.1694V39.7545ZM39.5077 29.0286C37.1254 29.0286 35.1873 27.0904 35.1873 24.7081C35.1873 22.3258 37.1254 20.3877 39.5077 20.3877C41.89 20.3877 43.8281 22.3258 43.8281 24.7081C43.8281 27.0904 41.89 29.0286 39.5077 29.0286Z"
                        fill="white"
                      />
                      <path
                        d="M39.7045 22.832H39.0781C38.7545 22.832 38.4922 23.0944 38.4922 23.418C38.4922 23.7415 38.7545 24.0039 39.0781 24.0039H39.1186V26.3471C39.1186 26.6707 39.3809 26.9331 39.7045 26.9331C40.0281 26.9331 40.2904 26.6707 40.2904 26.3471V23.418C40.2904 23.0944 40.0281 22.832 39.7045 22.832Z"
                        fill="white"
                      />
                    </svg>
                  </div>
                  <div>
                    <p className="text-gray-800 font-medium">E-mail</p>
                    <p className="text-gray-600">
                      <a href="mailto:info@maduramercerisers.com">
                        info@maduramercerisers.com
                      </a>
                    </p>
                  </div>
                </div>
                <div className="flex items-center space-x-4">
                  <div className="p-3  text-white">
                    {/* Address Icon */}
                    <svg
                      width="36"
                      height="36"
                      viewBox="0 0 60 61"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <rect
                        x="0.5"
                        y="1.08008"
                        width="59"
                        height="59"
                        rx="9.5"
                        fill="#465B83"
                      />
                      <rect
                        x="0.5"
                        y="1.08008"
                        width="59"
                        height="59"
                        rx="9.5"
                        stroke="#465B83"
                      />
                      <mask
                        id="mask0_694_148174"
                        // style="mask-type:luminance"
                        maskUnits="userSpaceOnUse"
                        x="15"
                        y="16"
                        width="30"
                        height="30"
                      >
                        <path
                          d="M44.5166 16.0664H15.4844V45.0987H44.5166V16.0664Z"
                          fill="white"
                        />
                      </mask>
                      <g mask="url(#mask0_694_148174)">
                        <path
                          d="M30.0006 16.293C23.8724 16.293 18.8867 21.2786 18.8867 27.4069C18.8867 30.3839 20.6903 34.2067 24.2473 38.7691C25.877 40.8539 27.6418 42.8294 29.5303 44.6829C29.657 44.804 29.8254 44.8715 30.0006 44.8715C30.1759 44.8715 30.3443 44.804 30.471 44.6829C32.3595 42.8294 34.1243 40.8539 35.754 38.7691C39.311 34.2067 41.1146 30.3839 41.1146 27.4069C41.1146 21.2786 36.1289 16.293 30.0006 16.293ZM30.0006 43.2334C27.9923 41.209 20.2476 33.0358 20.2476 27.4069C20.2476 22.0291 24.6228 17.6539 30.0006 17.6539C35.3785 17.6539 39.7536 22.0291 39.7536 27.4069C39.7536 33.0358 32.009 41.209 30.0006 43.2334Z"
                          fill="white"
                        />
                        <path
                          d="M35.45 26.4496L30.46 21.9133C30.3348 21.7994 30.1717 21.7363 30.0024 21.7363C29.8331 21.7363 29.6699 21.7994 29.5447 21.9133L24.5547 26.4496C24.4531 26.5419 24.3818 26.6629 24.3503 26.7966C24.3187 26.9302 24.3283 27.0703 24.3778 27.1985C24.4273 27.3265 24.5145 27.4366 24.6277 27.5142C24.741 27.5919 24.8751 27.6335 25.0125 27.6335H25.6929V31.0357C25.6929 31.2161 25.7646 31.3893 25.8922 31.5168C26.0198 31.6445 26.1929 31.7162 26.3734 31.7162H28.8683C29.0488 31.7162 29.2218 31.6445 29.3495 31.5168C29.477 31.3893 29.5487 31.2161 29.5487 31.0357V28.9944H30.456V31.0357C30.456 31.2161 30.5277 31.3893 30.6553 31.5168C30.7829 31.6445 30.956 31.7162 31.1365 31.7162H33.6314C33.8119 31.7162 33.9849 31.6445 34.1126 31.5168C34.2401 31.3893 34.3118 31.2161 34.3118 31.0357V27.6335H34.9923C35.1296 27.6335 35.2637 27.5919 35.377 27.5142C35.4903 27.4366 35.5775 27.3265 35.6269 27.1985C35.6765 27.0703 35.686 26.9302 35.6545 26.7966C35.6229 26.6629 35.5516 26.5419 35.45 26.4496ZM32.951 26.953V30.3552H31.8169V28.314C31.8169 28.1335 31.7452 27.9604 31.6176 27.8328C31.49 27.7052 31.3169 27.6335 31.1365 27.6335H28.8683C28.6878 27.6335 28.5148 27.7052 28.3871 27.8328C28.2596 27.9604 28.1879 28.1335 28.1879 28.314V30.3552H27.0538V26.953C27.0538 26.8286 27.0197 26.7066 26.9552 26.6001C26.8907 26.4937 26.7982 26.407 26.6879 26.3495L30.0024 23.3363L33.3169 26.3495C33.2065 26.407 33.1141 26.4937 33.0495 26.6001C32.9851 26.7066 32.9509 26.8286 32.951 26.953Z"
                          fill="white"
                        />
                      </g>
                    </svg>
                  </div>
                  <div>
                    <p className="text-gray-800 font-medium">Our Address</p>
                    <p className="text-gray-600">
                      No:5/87A, Angeripalayam Main Rd,
                      <br /> Vengamedu, Tirupur - 641 603, Tamil Nadu, India
                    </p>
                  </div>
                </div>
              </div>
            </div>

            {/* Right Section: Contact Form */}

            <div
              id="ContactUs"
              className="flex-1 p-4 bg-white rounded-xl mt-4 md:mt-0"
              style={{ scrollMarginTop: "80px" }}
            >
              <h2 className="text-xl md:text-3xl font-semibold text-gray-800 mb-4">
                Contact Us
              </h2>
              <form className="space-y-4">
                <div className="flex flex-col md:flex-row md:space-x-4">
                  <input
                    type="text"
                    placeholder="Enter first name"
                    className="p-3 border border-gray-300 rounded-lg flex-1"
                  />
                  <input
                    type="text"
                    placeholder="Enter last name"
                    className="p-3 border border-gray-300 rounded-lg flex-1 mt-4 md:mt-0"
                  />
                </div>
                <input
                  type="email"
                  placeholder="Enter your e-mail"
                  className="w-full p-3 border border-gray-300 rounded-lg"
                />
                <input
                  type="tel"
                  placeholder="Enter your phone no."
                  className="w-full p-3 border border-gray-300 rounded-lg"
                />
                <textarea
                  placeholder="Write Message"
                  className="w-full p-3 border border-gray-300 rounded-lg"
                ></textarea>
                <button
                  type="submit"
                  className="w-full p-3 bg-[#465B83] text-white rounded-lg hover:bg-[#3e4f70] transition-colors"
                >
                  Submit Message
                </button>
              </form>
            </div>
          </div>
          {/* Positioning the image at the bottom-left corner of the entire parent container */}
          <a href="mailto:info@maduramercerisers.com">
            <img
              src="/CatVector.png"
              alt="Background Image"
              className="hidden md:block absolute bottom-0 left-0 w-[40%] h-[50%] object-contain z-10"
            />
          </a>
        </div>
      </div>

      {/* contact us end */}
      {/* Footer start */}
      <FooterCatalogue />
      {/* Footer end */}
    </div>
  );
};

export default Catalogue;
